<form #form="ngForm" class="campanha-select-form" novalidate>
    <div class="row" *ngIf="config?.isShowPossuiCampanha">
        <div class="form-group col-12">
            <label class="col-form-label">{{possuiCampanhaLabel}}</label>
            <br/>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" name="possuiCampanha" id="possuiCampanhaSim" [value]="true" [ngModel]="possuiCampanha" (ngModelChange)="onChangePossuiCampanha($event)"
                    #possuiCampanhaModel="ngModel" #possuiCampanhaInput required="required" [attr.disabled]="canEditPossuiCampanha == false || null" [attr.readonly]="canEditPossuiCampanha == false || null">                     
                <label class="custom-control-label" for="possuiCampanhaSim">Sim</label>
            </div> 
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" name="possuiCampanha" id="possuiCampanhaNao" [value]="false" [ngModel]="possuiCampanha" (ngModelChange)="onChangePossuiCampanha($event)"
                    required="required" [attr.disabled]="canEditPossuiCampanha == false || null" [attr.readonly]="canEditPossuiCampanha == false || null">                     
                <label class="custom-control-label" for="possuiCampanhaNao">Não</label>
            </div> 
            <p class="form-text text-muted">
                {{possuiCampanhaHelpText}}
            </p>             
            <sgt-form-control-error
                *ngIf="possuiCampanhaModel.errors && possuiCampanhaModel.errors.required && possuiCampanhaModel.dirty"
                [msgError]="possuiCampanhaMsgError">
            </sgt-form-control-error>   
        </div>
    </div>

    <div class="row" *ngIf="config.isShowCampanha">
        <div class="form-group col-12">
            <label for="campanha" class="col-form-label">
                <span *ngIf="!editMode">
                    {{campanhaLabelInsert}}
                </span>
                <span *ngIf="editMode">
                    {{campanhaLabelEdit}}
                </span>                
            </label>

            <div class="input-group">
                <sgt-campanha-select
                    class="flex-grow-1"
                    #campanhaSelect
                    [ngModel]="idCampanha"
                    (ngModelChange)="onChangeCampanha($event)"
                    [campanha]="campanha"
                    #campanhaModel="ngModel"
                    name="campanha"
                    id="campanha"
                    [somenteEmAndamento]="true"
                    [objetivoVenda]="objetivoVenda"
                    [objetivoBonificacao]="objetivoBonificacao"
                    [objetivoAquisicao]="objetivoAquisicao"
                    [idClienteVinculado]="idClienteVinculado"
                    [idRepresentante]="idRepresentante"
                    [somenteClientesVinculados]="somenteClientesVinculados"
                    [disabled]="!canEdit"
                    [required]="config.isCampanhaRequired">
                </sgt-campanha-select>
                <div class="input-group-append" *ngIf="canInsert" style="margin-left: -3px;">
                    <button type="button" class="btn btn-light" (click)="insert.emit()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Campanha
                    </button>
                </div>
            </div>
            <p class="form-text text-muted" *ngIf="!editMode">
                {{campanhaHelpTextInsert}}
            </p>
            <p class="form-text text-muted" *ngIf="editMode">
                {{campanhaHelpTextEdit}}
            </p>                        
            <sgt-form-control-error
                *ngIf="campanhaModel.errors && campanhaModel.errors.required && campanhaModel.dirty"
                [msgError]="campanhaHelpMsgError">
            </sgt-form-control-error>             
        </div>
    </div>    
</form>